export { decodeUriComponentSafely } from '@terra/shared-asset-processing';

export const ELLIPSIS_SUFFIX = '...';

export function ellipsis(str: string, maxLength: number): string {
  return str.length > maxLength
    ? str.substring(0, maxLength) + ELLIPSIS_SUFFIX
    : str;
}

export function unescapeLiteralEscapeSequences(text: string): string {
  if (!text.includes('\\n') && !text.includes('\\t') && !text.includes('\\r')) {
    return text;
  }

  return text.replace(/\\n/g, '\n').replace(/\\t/g, '\t').replace(/\\r/g, '\r');
}

export function isValidJsonString(value: string): boolean {
  try {
    JSON.parse(value);

    return true;
  } catch {
    return false;
  }
}

const MAX_JSON_STRING_LENGTH = 100_000;

export function safeStringifyConfiguration(config: unknown): string {
  if (config === undefined) {
    return '{}';
  }

  if (typeof config === 'string') {
    return config;
  }

  if (
    typeof config === 'number' ||
    typeof config === 'boolean' ||
    config === null
  ) {
    return String(config);
  }

  try {
    const stringified = JSON.stringify(config);

    if (stringified.length > MAX_JSON_STRING_LENGTH) {
      throw new Error(
        `JSON exceeds maximum allowed length (${MAX_JSON_STRING_LENGTH} characters). Actual: ${stringified.length} characters`,
      );
    }

    return stringified;
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to stringify configuration';

    throw new Error(errorMessage);
  }
}
